<template>
  <div>
    <h3>Vertical Image</h3>
    <div class="row">
      <div class="col-3">
        <app-placeholder-vertical :imageId="form.imageId" @upload="onUpload"/>
      </div>
    </div>
    <hr>
    <h3>Gallery Images</h3>
    <div class="row">
      <div v-for="imageId in images" :key="imageId" class="col-3 mb-4">
        <img class="rounded" width="100%" :src="`https://ucarecdn.com/${ imageId }/-/scale_crop/300x300/center/-/quality/lighter/`">
      </div>
      <div class="col-3">
        <app-placeholder-square :refresh="false" @upload="onGalleryUpload"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppPlaceholderVertical from '@/components/App/AppPlaceholderVertical'
import AppPlaceholderSquare from '@/components/App/AppPlaceholderSquare'

export default {
  components: {
    AppPlaceholderVertical,
    AppPlaceholderSquare,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      images: this.product.images,
      form: {
        imageId: this.product.image_v_id,
      }
    }
  },
  methods: {
      async onUpload(imageId) {
        try {
          var { data } = await this.$http.put(`/products/${ this.product.id }/image`, {
            image_id: imageId,
            orientation: 'v',
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        }
        this.$message.success(data.message)
      },
      async onGalleryUpload(imageId) {
        try {
          var { data } = await this.$http.put(`/products/${ this.product.id }/images`, {
            image_id: imageId,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        }
        this.images.push(imageId)
        this.$message.success(data.message)
      },
  },
}
</script>

<style>

</style>
